import request from '@/utils/request'

export function submitQuot(param) {
    let data = param
    return request({
        url: `/quotation/hycot203/submitQuot`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'multipart/form-data' },
        data
    })
}